import { createAction, props } from '@ngrx/store';
import { Usuario, UsuarioForm } from '@core/models'
import { ResponseBadRequest } from '@core/interfaces';

export const USER_FIND = createAction('[User] Find', props<{ id: string }>());
export const USER_FIND_ALL = createAction('[User] Find All', props<{ search?: string, resellerId?: string, stateId?: string, accountId?: string }>());

export const USER_FIND_SUCCESS = createAction('[User] Find Success', props<{ user: Usuario }>());
export const USER_FIND_ALL_SUCCESS = createAction('[User] Find All Success', props<{ userList: Usuario[] }>());

export const USER_FAILURE = createAction('[User] Failure', props<{ error: ResponseBadRequest }>());

export const USER_UPDATE_LOADING = createAction('[User] Update Loading', props<{ loading: boolean }>());
export const USER_UPDATE_FORM = createAction('[User] Update Form', props<{ userForm: UsuarioForm }>());
export const USER_EDIT_MODE = createAction('[User] Edit Mode', props<{ editMode: boolean, isEditing: boolean }>());
export const USER_UPDATE_ID = createAction('[User] Update Id', props<{ userId: string|null }>());

export const USER_CREATE_VIEW = createAction('[User] Create View');
export const USER_UPDATE_VIEW = createAction('[User] Update View', props<{ userId: string }>());

export const USER_CREATE = createAction('[User] Create');
export const USER_UPDATE = createAction('[User] Update');
export const USER_UPDATE_ENABLED = createAction('[User] Update Enabled', props<{ id: string, userForm: UsuarioForm }>());
export const USER_REMOVE = createAction('[User] Remove', props<{ id: string }>());
export const USER_ACTIVATE = createAction('[User] Activate', props<{ id: string }>());
export const USER_DEACTIVATE = createAction('[User] Deactivate', props<{ id: string }>());

export const USER_CREATE_COMPLETED = createAction('[User] Create Completed');
export const USER_UPDATE_COMPLETED = createAction('[User] Update Completed');
export const USER_REMOVE_COMPLETED = createAction('[User] Remove Completed');

export const USER_RESET = createAction('[User] Reset');
export const USER_RESET_FORM = createAction('[User] Reset Form');
export const USER_RESET_ERROR = createAction('[User] Reset Error');
export const USER_CLEAR_STATE = createAction('[User] Clear State');